import { useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import InputText from "../../../../../global/InputText/InputText";
import SimpleButton from "../../../../../global/SimpleButton/SimpleButton";
import { addEditUrls } from "../../../../../services/api.enums";
import { addEditDataAPI } from "../../../../../services/CRUDServices";
import TooltipWrapper from "../../../../../global/tooltip/TooltipWrapper";
import { AddressValidation } from "global/Validation/Validation";

const EditCustomerAddressStep = ({
  data,
  CreateAddress,
  currentData,
  setAddressStep,
  setEditAddress,
  handleReset,
  setAddress,
  CloseModal,
}: any) => {
  const { orderData } = useSelector((state: any) => state.Order);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: AddressValidation,
    initialValues: currentData
      ? {
          ...currentData,
          lat: currentData.lat ? currentData.lat : currentData.latitude,
          lng: currentData.lng ? currentData.lng : currentData.longtitude,
        }
      : orderData?.returnAddressId
      ? {
          id: orderData?.returnAddressId,
          isActive: true,
          selectCity: {
            id: orderData.fromCountryDevisionId,
            text: orderData.fromCountryDevisionName,
          },
          selectAddressType: { id: 2, text: "آدرس عودت مرسولات" },
          name: orderData?.returnAddressTitle,
          postalCode: orderData?.returnAddressPostalCode,
          addressDetail: orderData?.returnAddressDetail,
          address: orderData?.returnAddressName,
          lat: orderData?.returnLat,
          lng: orderData?.returnLng,
        }
      : {
          isActive: true,
          selectCity: {
            id: orderData.fromCountryDevisionId,
            text: orderData.fromCountryDevisionName,
          },
          selectAddressType: { id: 2, text: "آدرس عودت مرسولات" },
          addressDetail: "",
          postalCode: "",
          address: "",
          isDefault: false,
          lat: data.lat,
          lng: data.lng,
        },
    onSubmit: (values: any) => {
      addEditDataAPI(
        addEditUrls.address,
        currentData || orderData?.returnAddressId ? "put" : "post",
        {
          ...values,
          longtitude: values.lng,
          latitude: values.lat,
          selectCustomer: { id: orderData.senderCustomerId },
          isEdited: false,
          selectRegChannel: { id: 2 },
        }
      ).then((res) => {
        if (res.data.status === "OK") {
          toast.success(
            `آدرس با موفقیت ${
              currentData || orderData?.returnAddressId ? "ویرایش" : "ساخته"
            } شد`
          );
          CreateAddress(res.data.payload);
        }
      });
    },
  });

  const { values, handleSubmit, handleChange, setFieldValue, errors, touched } =
    formik;

  useEffect(() => {
    // setFieldValue("address", data.address);
    setFieldValue("lat", data.lat);
    setFieldValue("lng", data.lng);
  }, [data, setFieldValue]);

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full sm:w-96 gap-4 min-h-[35rem]"
    >
      <p className="text-dark font-medium mb-3">
        {currentData || orderData?.returnAddressId
          ? "ویرایش آدرس"
          : "آدرس جدید"}{" "}
      </p>
      <InputText
        important
        readOnly
        wrapperClassName="w-full"
        values={orderData.fromCountryDevisionName}
        label="شهر"
      />
      <div className="relative">
        <TooltipWrapper
          textProps={values.address}
          extraClass="absolute top-[-13px] opacity-[0]"
        >
          {values.address.length > 37 && values.address}
        </TooltipWrapper>
        <InputText
          important
          label="آدرس"
          name="address"
          wrapperClassName="w-full"
          values={values.address}
          handleChange={handleChange}
          error={touched.address && errors.address}
        />
      </div>
      <InputText
        important
        wrapperClassName="w-full"
        handleChange={handleChange}
        values={values.addressDetail}
        name="addressDetail"
        error={touched.addressDetail && errors.addressDetail}
        label="جزئیات"
      />
      <InputText
        wrapperClassName="w-full"
        handleChange={handleChange}
        values={values.postalCode}
        name="postalCode"
        error={touched.postalCode && errors.postalCode}
        label="کد پستی"
      />
      <InputText
        wrapperClassName="w-full"
        handleChange={handleChange}
        values={values.name}
        name="name"
        label="عنوان برای ذخیره"
      />
      <div className="btnForm mt-0">
        <SimpleButton
          handelClick={() => {
            if (orderData?.returnAddressId && !currentData) {
              CloseModal(false);
            } else {
              setAddressStep(2);
              setEditAddress(false);
              handleReset();
              setAddress();
            }
          }}
          className="full-lightTomato-btn w-full"
          text="لغو"
        />
        <SimpleButton
          type="submit"
          className="full-tomato-btn w-full"
          text="تایید"
        />
      </div>
      {/* {orderData?.returnAddressId && !currentData && (
        <p
          className="text-center cursor-pointer mt-2"
          onClick={() => {
            handleReset();
            setAddressStep(2);
          }}
        >
          لیست آدرس ها
        </p>
      )} */}
    </form>
  );
};

export default EditCustomerAddressStep;
